import type { AuthState } from '../app/contexts/AuthContext';

export type AppRouteKey =
  | 'dashboard'
  | 'weighing'
  | 'tickets'
  | 'reports'
  | 'companies'
  | 'users'
  | 'configuration';

const STATIC_SEGMENTS: Record<AppRouteKey, string> = {
  dashboard: 'dashboard',
  weighing: 'weighing',
  tickets: 'tickets',
  reports: 'reports',
  companies: 'companies',
  users: 'users',
  configuration: 'configuration',
};

const TENANT_SCOPED_ROUTES = new Set<AppRouteKey>([
  'dashboard',
  'weighing',
  'tickets',
  'reports',
  'configuration',
]);

export function buildAppPath(routeKey: AppRouteKey, authState: AuthState): string {
  const segment = STATIC_SEGMENTS[routeKey];
  const slug = authState.company?.slug;
  const isTenantScoped = TENANT_SCOPED_ROUTES.has(routeKey);

  if (
    isTenantScoped &&
    authState.user &&
    authState.user.role !== 'super_admin' &&
    slug
  ) {
    return `/${slug}/${segment}`;
  }

  return `/${segment}`;
}

export function getDefaultAppPath(authState: AuthState): string {
  if (!authState.user) {
    return '/login';
  }

  if (authState.user.role === 'super_admin') {
    return buildAppPath('companies', authState);
  }

  if (authState.user.role === 'agent') {
    return buildAppPath('weighing', authState);
  }

  if (authState.user.role === 'accounting') {
    return buildAppPath('reports', authState);
  }

  return buildAppPath('dashboard', authState);
}
